import { render, staticRenderFns } from "./ZhiZhuPay.vue?vue&type=template&id=4784d2e7"
import script from "./ZhiZhuPay.vue?vue&type=script&lang=js"
export * from "./ZhiZhuPay.vue?vue&type=script&lang=js"
import style0 from "./ZhiZhuPay.vue?vue&type=style&index=0&id=4784d2e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports